/**
 * dateformatter creates the window.formatDate function.
 *
 * window.formatDate formats an ISO date (usually passed by the API) and converts it to a local datestring with format DD/MM/YYYY
 * - str: String      (String, ie '2015-03-25T12:00:00Z')
 */

function dateformatter () {
	window.currentDateFormat = 'yy-mm-dd';

	window.formatDate = function (str, format) {
		const date = new Date(str);
		if (isNaN(date) == false) {
			return $.datepicker.formatDate(format || window.currentDateFormat, date);
		}
		return '';
	};

	window.formatDateTime = function (str, format, empty) {
		const d = new Date(str);
		if (d.getTime() > 0) {
			let h = d.getHours();
			h = h < 10 ? `0${h}` : h;

			let m = d.getMinutes();
			m = m < 10 ? `0${m}` : m;

			let s = d.getSeconds();
			s = s < 10 ? `0${s}` : s;

			let datetext = window.formatDate(str, format);
			datetext = `${datetext} ${h}:${m}:${s}`;
			return datetext;
		}
		return empty || '';
	};

	Vue.filter('formatDate', window.formatDate);
	Vue.filter('formatDateTime', window.formatDateTime);
}
dateformatter();
